import SubscriptionDetails from './SubscriptionDetails';

export default SubscriptionDetails;
